module.exports = __webpack_public_path__ + "img/headSculpture1.dbc94f23.png";